import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import hygkImg from '../../images/home/hygk.png'
import useMediaQuery from '../../hooks/useMediaQuery'
import { Col, Row } from 'antd'
import { BASE_URL } from '../../api/api'
import NavLink from '../navLink'

const data = Array(4)
  .fill()
  .map(() => ({
    name: '姓名',
    title: '这里是具体职务的介绍',
    img: hygkImg,
    message:
      '这里是发言人的言论内容这里是发言人的言论内容这里是发言人的言论内容这里是发言人的言论内容这里是发言人的言论内容这里是发言人的言论内容…'
  }))

const Ztlt = ({ subjectList = {} }) => {
  const isMobile = useMediaQuery()
  const { channel, list = [] } = subjectList
  const { id, name } = channel || {}
  console.log(list)

  return (
    <div className="w-full lg:bg-homeZjzk bg-cover bg-[#E7E7E7]  mt-[60px] px-5 lg:px-0 pb-10">
      <div className="max-w-1200 mx-auto pt-[41px]">
        <div className="flex justify-center lg:justify-between items-center">
          <p className="hidden lg:block"></p>
          <H2Title title={name} />
          <GenDuo href={`/hyjj/channel_id/${id}`} className="hidden lg:block" />
        </div>
        {isMobile ? (
          <div>
            <Row gutter={16}>
              {list.map(({ title, image = '', description, id, outlink }, key) => (
                <Col className="mt-6" key={key} span={12}>
                  <NavLink isOutLink={!!outlink} to={outlink || `/wzxq/id/${id}`} key={id}>
                    <div className="bg-white p-2">
                      <p className="mt-4 text-[#333]">{title}</p>
                      <hr className="w-[100px] bg-[#0189D5] h-[2px]" />
                      <p className="mt-2 text-sm text-[#555555] font-sourceHan leading-[28px] text-ellipsis overflow-hidden h-[90px]">
                        {description}
                      </p>
                      <img src={`${BASE_URL}/${image}`} alt="" />
                    </div>
                  </NavLink>
                </Col>
              ))}
            </Row>
            <div className="flex lg:hidden justify-center">
              <GenDuo
                href={`/hyjj/channel_id/${id}`}
                className="mx-auto mt-[30px] bg-[#0189D5] px-6 py-2 rounded-xl text-white"
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-between flex-wrap">
            {list.map(({ title, image = '', description, id, outlink }, key) => (
              <NavLink isOutLink={!!outlink} to={outlink || `/wzxq/id/${id}`} key={id}>
                <div key={key} className="w-[280px] mt-9 p-2 bg-white">
                  <p className="mt-4 text-[#333] line-clamp-1">{title}</p>
                  <hr className="w-[180px] bg-[#0189D5] h-[4px]" />
                  <p className="mt-4 text-sm text-[#555555] font-sourceHan leading-[28px] line-clamp-3">
                    {description}
                  </p>
                  <img src={`${BASE_URL}${image}`} style={{ height: 179 }} alt="" />
                </div>
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Ztlt
